import React, { useEffect, useState } from "react";
import api from "./services/api";
import { Cursor } from "./components/Cursor";
import { ProgressBar } from "./components/ProgressBar";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Projects } from "./components/Projects";
import { Experience } from "./components/Experience";
import { Education } from "./components/Education";
import { CTA } from "./components/CTA";
import { Publications } from "./components/Publications";
import { FloatingChat } from "./components/FloatingChat";
import { ChatProvider } from "./components/ChatContext";

export default function App() {
  const [language, setLanguage] = useState(sessionStorage.getItem('lang') || 'fr');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({
    personalInfo: null,
    projects: [],
    experiences: [],
    education: [],
    publications: [],
  });

  // Fetch data on mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [pi, proj, exp, edu, pub] = await Promise.all([
          api.getPersonalInfo(language),
          api.getProjects(language),
          api.getExperience(language),
          api.getEducation(language),
          api.getPublications(language),
        ]);


        setData({
          personalInfo: pi,
          projects: proj,
          experiences: exp,
          education: edu,
          publications: pub,
        });
      } catch (err) {
        console.error("Error fetching CV data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [language]);

  // Hide default cursor
  useEffect(() => {
    document.body.style.cursor = "none";
    return () => { document.body.style.cursor = "auto"; };
  }, []);

  // No loading screen — render immediately, data will populate as it arrives

  return (
    <ChatProvider>
      <div
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          background: "#050508",
          minHeight: "100vh",
        }}
      >
        <Cursor />
        <ProgressBar />
        <Nav personalInfo={data.personalInfo} language={language} setLanguage={(l: string) => {
          setLanguage(l);
          sessionStorage.setItem('lang', l);
        }} />
        <main>
          <Hero personalInfo={data.personalInfo} language={language} />
          <About personalInfo={data.personalInfo} language={language} />
          <Projects projects={data.projects} language={language} />
          <Experience experiences={data.experiences} education={data.education} language={language} />
          <Education education={data.education} language={language} />
          <Publications publications={data.publications} language={language} />
          <CTA personalInfo={data.personalInfo} language={language} />
        </main>

        {/* Footer */}
        <footer
          className="py-8 text-center"
          style={{
            background: "#07070b",
            borderTop: "1px solid rgba(255,255,255,0.04)",
          }}
        >
          <p
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
              color: "rgba(255,255,255,0.2)",
              letterSpacing: "0.1em",
            }}
          >
            © 2026 SAMI CAKIRAL — DESIGNED & CODED WITH ♥ &amp; ☕
          </p>
        </footer>
        <FloatingChat language={language} />
      </div>
    </ChatProvider>
  );
}